import React, { useEffect, useState } from "react";
import axios from "axios";

export default function PayPage() {
  const {
    renderTapCard,
    Theme,
    Currencies,
    Direction,
    Edges,
    Locale,
    tokenize,
  } = window.CardSDK;

  const [errorData, setErrorData] = useState(null);

  useEffect(() => {
    const { unmount } = renderTapCard("card-sdk-id", {
      publicKey: "pk_test_EtHFV4BuPQokJT6jiROls87Y",
      merchant: { id: null },
      transaction: { amount: 1, currency: Currencies.BHD },
      acceptance: {
        supportedBrands: ["AMERICAN_EXPRESS", "VISA", "MASTERCARD", "MADA"],
        supportedCards: "ALL",
      },
      fields: { cardHolder: true },
      addons: { displayPaymentBrands: true, loader: true, saveCard: true },
      interface: {
        locale: Locale.EN,
        theme: Theme.DARK,
        edges: Edges.CURVED,
        direction: Direction.LTR,
      },

      onReady: () => console.log("onReady"),
      onError: (data) => {
        console.log("onError", data);
        setErrorData(data);
      },
      onSuccess: (data) => {
        const options = {
          method: "POST",
          url: "https://tp-api.alsendi.me/pay/",
          headers: {
            accept: "application/json",
            "content-type": "application/json",
          },
          data: {
            amount: 1,
            currency: "BHD",
            customer_initiated: true,
            threeDSecure: true,
            save_card: true,
            reference: { transaction: "txn_01", order: "ord_01" },
            customer: {
              first_name: "ALI",
              email: "alialsendi98@gmail.com",
            },
            merchant: { id: data["merchant"]["id"] },
            source: { id: data["id"] },
            redirect: { url: "https://tap-payment.alsendi.me/payment-status" },
          },
        };

        axios
          .request(options)
          .then((res) => {
            window.location.href = res["data"]["transaction"]["url"];
          })
          .catch((err) => {
            console.log("onError", err);
            setErrorData(err);
          });
      },
    });

    return () => unmount();
  }, [Currencies.BHD,Direction.LTR, Edges.CURVED, Locale.EN, Theme.DARK,renderTapCard]);

  function pay() {
    tokenize();
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1>Secure Payment</h1>
        <h4>Developed By Ali AlSendi</h4>
      </header>

      <main className="App-main">
        <div className="card-container">
          <div id="card-sdk-id" />
          {errorData && (
            <div className="result error">
              <h3>Payment Error</h3>
            </div>
          )}
          <button className="pay-button" onClick={pay}>
            Pay Now
          </button>
        </div>
      </main>
    </div>
  );
}